module.exports = __webpack_public_path__ + "static/media/Bubble_Tea_tapioca_pearl-12-512.27c8c18d.png";